import { render } from "./XIconSolidShoppingBag.vue?vue&type=template&id=7c2d4272"
import script from "./XIconSolidShoppingBag.vue?vue&type=script&lang=js"
export * from "./XIconSolidShoppingBag.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidShoppingBag.vue"]])

export default __exports__